// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__szBbK","column3":"style_column3__jtmG5","column2":"style_column2__hAYUx","gridItem":"style_gridItem__-Skvp"};